import { render, staticRenderFns } from "./MessageAdmin.vue?vue&type=template&id=f5c9638e&scoped=true&"
import script from "./MessageAdmin.vue?vue&type=script&lang=js&"
export * from "./MessageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MessageAdmin.vue?vue&type=style&index=0&id=f5c9638e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c9638e",
  null
  
)

export default component.exports